import React from 'react';
import PropTypes from 'prop-types';
import { get, forEach } from 'lodash';
import SearchForm from './SearchForm';
import SearchResult from './SearchResult';
import { defaultTracking } from '../lib/tracking';
import { FPTI } from '../lib/constants';
import Marketplaces from '../../lib/singletons/marketplaces';
import Partners from '../../lib/singletons/partners';

class ToolsSearch extends React.Component {
  state = {
    search: '',
    result: [],
    stateModified: false
  };

  searchTimer;
  fptiTimer;

  componentDidMount() {
    // the favorite toggle action reset the state, so we repopulate
    // the search with the saved search state to keep context
    if (!this.state.stateModified && this.props.search.search.length > 0) {
      const { search, result } = this.props.search;
      this.updateResult(search, result);
    }
  }

  handleSearch = event => {
    const value = event.target.value;

    this.setState({
      search: value,
      stateModified: true
    });

    // displaying the result with `onchange` fires the render action multiple times - this
    // creates an issue with the state inside the component - i.e.  mismatch of active / inactive
    // state for favorite icon - to solve this issue, we need to wait until user finishes with
    // their typing action
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      const { tools } = this.props;

      let results = [];
      let toolsNames = Object.keys(tools),
        marketplaces = Marketplaces.instance(),
        marketplaceNames = Object.keys(marketplaces),
        partners = Partners.instance(),
        partnerNames = Object.keys(partners),
        combined = toolsNames.concat(marketplaceNames).concat(partnerNames);

      if (
        value.length === document.getElementById('tools-search').value.length
      ) {
        forEach(combined, key => {
          let valueToCompare = value.toLowerCase();
          [tools, marketplaces, partners].forEach(item => {
            if (
              get(item, `[${key}].name`, '')
                .toLowerCase()
                .includes(valueToCompare)
            ) {
              results.push(item[key]);
            }
          });
        });

        // timeout is needed here because we want to make sure user has stopped
        // typing and is actively using the search result
        clearTimeout(this.fptiTimer);
        this.fptiTimer = setTimeout(() => {
          const { recordClick, tracking, user } = this.props,
            custId = get(user, 'encryptedAccountNumber');
          if (
            value.length ===
            document.getElementById('tools-search').value.length
          ) {
            recordClick(tracking, {
              ...defaultTracking({ custId }),
              page: `${FPTI.pgrp}::search`,
              link: 'tools-search',
              srch: value
            });
          }
        }, 1500);

        this.updateResult(value, results);
      }
    }, 500);
  };

  clearSearch = () => {
    this.updateResult('', []);
  };

  updateResult = (value, results) => {
    this.setState({
      search: value,
      result: results,
      stateModified: true
    });

    let list = document.getElementById('tools-list');
    if (list) {
      list.style.display = value ? 'none' : 'block';
    }

    // manually deactivate the active tab
    let activeTabs = document.getElementsByClassName('Tabs-tab-active');
    if (activeTabs.length) {
      forEach(activeTabs, ele => {
        ele.classList[value ? 'add' : 'remove']('search-active');
      });
    }
  };

  toggleFavoriteFromSearch = tool => {
    const updatedResults = this.state.result.map(t => {
      //redux state acts funny if we don't clone the object here
      const clone = JSON.parse(JSON.stringify(t));
      if (clone.key === tool.key) {
        clone.favorite = !clone.favorite;
      }
      return clone;
    });

    const search = {
      search: this.state.search,
      result: updatedResults
    };
    this.props.toggleFavorite(tool, search);
  };

  render() {
    const { setTool, setApp, user } = this.props;
    const { search } = this.state;

    return (
      <div id="tools-search-wrapper">
        <SearchForm
          search={search}
          clearSearch={this.clearSearch}
          handleSearch={this.handleSearch}
        />
        {search && (
          <SearchResult
            {...this.state}
            user={user}
            setTool={setTool}
            setApp={setApp}
            clearSearch={this.clearSearch}
            toggleFavorite={this.toggleFavoriteFromSearch}
          />
        )}
      </div>
    );
  }
}

ToolsSearch.propTypes = {
  user: PropTypes.object,
  tools: PropTypes.object,
  toggleFavorite: PropTypes.func,
  setTool: PropTypes.func,
  setApp: PropTypes.func,
  search: PropTypes.object,
  recordClick: PropTypes.func,
  tracking: PropTypes.object
};

export default ToolsSearch;
